import { Box, IconButton, Tooltip } from '@mui/material';
import { FilterAltOff, Search } from '@mui/icons-material';

import {
  CustomAutoComplete,
  CustomTextField,
  HorizontalForm,
  renderTwoLineOption,
} from '../../../common/components';
import { VALUATION_STATUS_OPTIONS, VALUATION_TEXTS } from '../constants/materialValuationConstants';
import { AUTOCOMPLETE_LISTBOX_PROPS } from '../../../common/styles';
import { toWarehouseOptions } from '../../utils/toWarehouseOptions';
import { MATERIAL_OPTION_TEXTS } from '../../constants/materialOptionTexts';
import { getFilterFieldSx } from '../../utils/getFilterFieldSx';

const toolbarSx = {
  px: 2.5,
  py: 1.5,
  gap: 1.25,
  alignItems: 'center',
  flexWrap: { xs: 'wrap', lg: 'nowrap' },
};

/**
 * Toolbar de filtros de la pestaña activa, en una sola fila.
 * La variante `stocks` suma depósito y estado; `sources` solo busca por material.
 * @param {Object} props
 * @param {'stocks'|'sources'} props.variant Pestaña que filtra.
 * @param {Object} props.filters Valores vigentes (`search`, `uuid_warehouse`, `status`).
 * @param {Array<Object>} [props.warehouses] Depósitos para el filtro.
 * @param {Function} props.onChange Recibe (nombre, valor).
 * @param {Function} props.onClear Limpia filtros y orden.
 * @returns {JSX.Element}
 */
const MaterialValuationFilters = ({ variant, filters, warehouses = [], onChange, onClear }) => (
  <Box sx={{ backgroundColor: 'background.paper', borderBottom: '1px solid #ccc' }}>
    <HorizontalForm withBorder={false} sx={toolbarSx}>
      <CustomTextField
        label={VALUATION_TEXTS.searchMaterial}
        name="search"
        value={filters.search || ''}
        onChange={(event) => onChange('search', event.target.value)}
        sx={getFilterFieldSx(2, 260)}
        InputProps={{
          startAdornment: <Search sx={{ color: 'primary.main', mr: 1 }} />,
        }}
      />
      {variant === 'stocks' && (
        <>
          <CustomAutoComplete
            label={VALUATION_TEXTS.warehouse}
            name="uuid_warehouse"
            value={filters.uuid_warehouse || ''}
            options={toWarehouseOptions(warehouses)}
            renderOption={renderTwoLineOption}
            inputPlaceholder={MATERIAL_OPTION_TEXTS.searchWarehouse}
            ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
            onChange={(event) => onChange('uuid_warehouse', event.target.value)}
            sx={getFilterFieldSx(1, 160)}
          />
          <CustomAutoComplete
            label={VALUATION_TEXTS.status}
            name="status"
            value={filters.status || ''}
            options={VALUATION_STATUS_OPTIONS}
            onChange={(event) => onChange('status', event.target.value)}
            sx={getFilterFieldSx(1, 160)}
          />
        </>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
        <Tooltip title={VALUATION_TEXTS.clearFilters}>
          <IconButton color="primary" onClick={onClear}>
            <FilterAltOff />
          </IconButton>
        </Tooltip>
      </Box>
    </HorizontalForm>
  </Box>
);

export default MaterialValuationFilters;
